export const createAnnotationId = (group, id) => `annotation-${group}-${id}`;

export const createParentAnnotationId = (group, id) => `annotation-parent-${group}-${id}`;
